import React, { useEffect } from 'react';

import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

const setDocumentTitle = ({ pathname }) => {
  if (pathname.startsWith('/design')) document.title = 'NSW Plant Design Registration';
  else if (pathname.startsWith('/item-renewal')) document.title = 'NSW Plant Item Registration Renewal';
  else document.title = 'NSW Plant Item Registration';
};

export const RouteChangeTracker = () => {
  let location = useLocation();

  useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);

    setDocumentTitle(location);
  }, [location]);

  return <></>;
};
